import { LinkContentFragment } from "../../graphql/graphql.ts";
import { LocaleConfig } from "../../utils/GlobalContext.ts";
import { formatAnchorLinkId } from "../../utils/formatAnchorLinkId.ts";

export type CmsLinkProps = {
  ariaLabel?: string;
  children: string;
  href: string;
  download?: boolean;
};

export function linkTransformer({
  link,
  localeConfig,
}: {
  link?: LinkContentFragment | null;
  localeConfig: LocaleConfig;
}): CmsLinkProps {
  const emptyLink = {
    children: "",
    href: "#",
    target: "_self",
    ariaLabel: "",
  };

  if (!link) {
    return emptyLink;
  }

  if (link.file?.url) {
    return {
      children: link.label ?? "",
      href: link.file.url,
      target: "_blank",
      download: true,
    } as CmsLinkProps;
  }

  const componentReference = link.componentReference
    ? `#${formatAnchorLinkId(link.componentReference.sys.id)}`
    : "";

  const formattedSlug = link.pageReference?.slug
    ? link.pageReference?.slug === "/"
      ? "/"
      : `/${link.pageReference?.slug}`
    : "";

  return {
    children: link.label ?? "",
    href: formattedSlug
      ? `/${localeConfig?.currentLocale.toLowerCase()}${formattedSlug}${componentReference}`
      : componentReference
        ? componentReference
        : (link.url ?? ""),
    target:
      link.pageReference?.slug || Boolean(componentReference)
        ? "_self"
        : "_blank",
  } as CmsLinkProps;
}
